<div class="business-list-view gs-cm-page col-md-12 padding-right-0 padding-left-0">
  <div class="hpanel">
    <div class="panel-body gs-cm-toolbar border-radius-top-left-right-6">
      <div class="gs-cm-toolbar__title">
        <label class="gs-cm-toolbar__title-label" data-toggle="tooltip" data-placement="top"
          title="{{ communityData?.communityName }}">
          {{communityData?.communityName | truncate: 15 }}
        </label>
        <p class="gs-cm-toolbar__title-meta" *ngIf="total === 0 || total === 1">{{ total }} Member</p>
        <p class="gs-cm-toolbar__title-meta" *ngIf="total > 1">{{ total }} Members</p>
      </div>

      <div class="gs-cm-toolbar__search">
        <ng-icon name="tablerSearch" class="gs-cm-toolbar__search-icon"></ng-icon>
        <input #communityDataText type="text" class="form-control" placeholder="Search Member"
          name="searchmember" (keyup)="onSearchCommunity(communityDataText.value)"/>
      </div>

      <div class="gs-cm-toolbar__filter">
        <div class="btn-group unified-btn" dropdown container="body" placement="bottom right">
          <!-- Single Filter Button -->
          <button type="button" class="btn primary-btn filter-single-btn" dropdownToggle data-toggle="dropdown">
            <span>{{ selectedFilter|titlecase }}</span>
            <ng-icon name="tablerFilter"></ng-icon>
          </button>
          <!-- Dropdown -->
          <ul class="dropdown-menu no-padding dropdown-menu-right leftview" *dropdownMenu role="menu">
            <li role="menuitem">
              <a class="dropdown-item" [class.selected]="selectedFilter === 'All'" (click)="setFilter('All')">All<span class="sr-only">(current)</span></a>
            </li>
            <li role="menuitem">
              <a class="dropdown-item" [class.selected]="selectedFilter === 'ADMIN'" (click)="setFilter('ADMIN')">Admin</a>
            </li>
            <li role="menuitem">
              <a class="dropdown-item" [class.selected]="selectedFilter === 'REVOKED'" (click)="setFilter('REVOKED')">Revoked</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="gs-cm-toolbar__advanced">
        <button class="btn primary-btn btn-sm">Advance Search</button>
      </div>
    </div>
  </div>


  <ng-container *ngIf="loadAPIcall && !loadScroll">
    <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0 pd-5"
      *ngFor="let n of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
      <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
    </div>
  </ng-container>

  <div>
    <div class="community-body" *ngIf="(communityList | async)?.length > 0" infiniteScroll [alwaysCallback]="true"
      [infiniteScrollDistance]="5" [infiniteScrollThrottle]="300" (scrolled)="onScrollDown()">

      <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0 pd-5"
        *ngFor="let data of (communityList | async)">
        <app-user-card [userDataInput]="data" [config]="userCardConfig" [button]="'PRIMARY'" [refresh]="true">
        </app-user-card>
      </div>

      <ng-container *ngIf="loadScroll">
        <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0 pd-5"
          *ngFor="let n of [1, 2, 3]">
          <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
        </div>
      </ng-container>


      <div class="col-sm-12 pl-1 end" *ngIf="stopScroll && (communityList | async)?.length > 0"
        style="text-align: center;padding-top: 1rem;">
        <div class="col-sm-12">
          <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
        </div>
        <div class="col-sm-12">
          <p class="fontchange">You've reached the bottom of the page</p>
        </div>
      </div>

    </div>
    <div class="col-sm-12"
      *ngIf="(communityList | async)?.length === 0 && !loadAPIcall && communitypayload?.searchContent">
      <app-nodata-found
        screen="SEARCH"
        [title]="['No results found', 'Try adjusting your search']"
        [buttonShow]="false">
      </app-nodata-found>
    </div>

    <div class="col-sm-12"
      *ngIf="(communityList | async)?.length === 0 && !loadAPIcall && !communitypayload?.searchContent">
      <app-nodata-found [title]="noDatafound"></app-nodata-found>
    </div>
  </div>

  <!-- <div *ngIf="revokeData">
    <div class="col-sm-12 col-md-6 col-lg-4 pd-5"
      *ngFor="let data of RevokeFilterData | customFilter:{userName:searchKeyData}:false ">
      <app-user-card [userDataInput]="data" [button]="'PRIMARY'" [refresh]="true"></app-user-card>
    </div>
    <div class="ivite" *ngIf="RevokeFilterData?.length < 1">
    </div>
    <div class="col-md-12 pad" *ngIf="RevokeFilterData?.length === 0">
      <app-nodata-found [title]="noDatafoundrevoke"></app-nodata-found>
    </div>
  </div> -->


  <!-- <div *ngIf="adminData">
    <div class="col-sm-12 col-md-6 col-lg-4 pd-5"
      *ngFor="let data of AdminFilterData | customFilter:{userName:searchKeyData}:false  ">
      <app-user-card [userDataInput]="data" [button]="'PRIMARY'" [refresh]="true"></app-user-card>
    </div>
    <div class="ivite" *ngIf="AdminFilterData?.length < 1">
    </div>

    <div class="col-md-12 pad" *ngIf="AdminFilterData?.length==0">
      <app-nodata-found [title]="noDatafoundadmin"></app-nodata-found>
    </div>
  </div> -->


  <div *ngIf="invitedMember">
    <div class="col-sm-12 col-md-6 col-lg-4 pd-5"
      *ngFor="let data of inivateAcceptdata | customFilter:{userName:searchKeyData}:false ">
      <app-user-card *ngIf="inivateAcceptdata?.length > 1" [userDataInput]="data" [button]="'PRIMARY'" [refresh]="true">
      </app-user-card>
    </div>
    <div class="ivite n" *ngIf="inivateAcceptdata?.length < 1">
    </div>
    <div class="col-md-12 pad" *ngIf="inivateAcceptdata?.length==0">
      <app-nodata-found [title]="noDatafoundinvited"></app-nodata-found>
    </div>
  </div>
</div>
